export const iosURL = 'https://apps.apple.com/my/app/homexpert-warranty-service/id6472608588';
export const androidURL = 'https://play.google.com/store/apps/details?id=laoyi.HomExpert&hl=en';
export const iosURLFacilities = 'https://apps.apple.com/app/supermedic-facilities/id6443664368';
export const androidURLFacilities = 'https://play.google.com/store/apps/details?id=com.supermedic.facilities';